import { ReactComponent as IconArrowRight } from './assets/icon-arrow-right.svg'
import { ReactComponent as IconClose } from './assets/icon-close.svg'
import { ReactComponent as IconCheck } from './assets/icon-check.svg'
import { ReactComponent as IconDrag } from './assets/icon-drag.svg'
import { ReactComponent as IconReload } from './assets/icon-reload.svg'

export const iconsList = {
  'arrow-right': IconArrowRight,
  'close': IconClose,
  'check': IconCheck,
  'drag': IconDrag,
  'reload': IconReload,
}
